var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationMarkerTg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2846 2.95061C6.4414 0.793806 9.93828 0.793806 12.0951 2.95061C14.2519 5.10742 14.2519 8.60429 12.0951 10.7611L8.18984 14.6663L4.2846 10.7611C2.12779 8.60429 2.12779 5.10742 4.2846 2.95061ZM8.18984 8.43381C9.06132 8.43381 9.7678 7.72734 9.7678 6.85586C9.7678 5.98437 9.06132 5.2779 8.18984 5.2779C7.31836 5.2779 6.61188 5.98437 6.61188 6.85586C6.61188 7.72734 7.31836 8.43381 8.18984 8.43381Z",
    fill: "#009799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationMarkerTg);
export default __webpack_public_path__ + "static/media/icon-location-marker-tg.f232eddd9106e4fe51067369deeda4e2.svg";
export { ForwardRef as ReactComponent };